import React, { useContext } from "react";
import "./LogoutModel.scss";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import MyContext from "../Context/MyContext";

const LogoutModel = () => {
  const { closeLogoutModal, LogoutOpen, handleLogout } =
    useContext(MyContext);

  return (
    <Modal
      open={LogoutOpen}
      onClose={closeLogoutModal}
      center
      classNames={{
        modal: "logout-modal",
        overlay: "logout-overlay",
      }}
    >
      <div className="logout-content">
        <h2>Logout</h2>
        <p>Are you sure you want to logout?</p>

        <div className="logout-actions">
          <button className="btn cancel" onClick={closeLogoutModal}>
            Cancel
          </button>
          <button className="btn logout" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LogoutModel;
